import { all, call, fork, put, select, take, takeEvery } from 'redux-saga/effects';
import userActions from '../user/actions';
import { selectCompanyIDSaga } from '../../common/saga/selectors';
import PusherClient from '../../components/shared/pusherClient';
import { createPusherReduxAction, PusherActionType } from './PusherActions';
import { eventChannel } from 'redux-saga';
import { getCompanyID } from '../selectors';
import { scheduleActions } from '../../pages/data/organization/crew-scheduling-v3/redux-saga/actions';

const PUSHER_RECONNECTED = Symbol('PUSHER_RECONNECTED');

function createPusherChannel(companyID: string) {
  return eventChannel(emitter => {
    const onReconnected = () => {
      emitter({ type: PUSHER_RECONNECTED });
    };

    const pusherInstance = PusherClient.getInstance(onReconnected);
    const realtimeBroadcast = pusherInstance.subscribe(`${companyID}`);

    const eventHandler = (action: PusherActionType) => (data: any) => {
      emitter({ action, data });
    };

    for (const action of Object.values(PusherActionType)) {
      realtimeBroadcast.bind(action, eventHandler(action));
    }

    return () => {
      realtimeBroadcast.unsubscribe();
    };
  });
}

function* watchCompanyLoaded() {
  const { isCompanyLoaded } = yield select(({ user }) => user);

  if (!isCompanyLoaded) {
    yield take(userActions.SET_COMPANY);
  }

  const companyID = yield* selectCompanyIDSaga();

  const pusherChannel = yield call(createPusherChannel, companyID);

  while (true) {
    const payload = yield take(pusherChannel);

    if (payload.type === PUSHER_RECONNECTED) {
      yield put(scheduleActions.reFetchAllEntries());
      continue;
    }

    const action = createPusherReduxAction(payload.action, payload.data);
    yield put(action);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(userActions.SET_COMPANY, function*() {
      yield fork(watchCompanyLoaded);
    }),
    takeEvery(userActions.LOGOUT, function*() {
      const pusher = PusherClient.getInstance();
      const companyID = yield select(getCompanyID);
      pusher.unsubscribe(companyID);
    }),
  ]);
}
